// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-history-main-wrap .shimmer.shimmer-thumbnail.border-rounded {
    padding-bottom: 0px;
    margin-bottom: 0px;
    border-radius: 20px;
    height: 163px !important;
}

.service-item-grid .shimmer-card {
    width: 103px !important;
    height: 134px;
    border: 1px solid #f3f3f3;
    border-radius: 15px;
    box-shadow: unset;
    overflow: hidden;
}

.shimmer-service-item-card-wrap{
    margin-bottom: 20px;
}

.summer-effect-item-wrap{
    margin-top: 12px;
}

.shimmer.shimmer-thumbnail.mb-0 {
    height: 78px !important;
}

.service-item-grid .p-30 {
    padding: 4px 16px;
}

.shimmer-title--secondary .shimmer-title-line {
    height: 10px;
}


  .service-item-grid{
    display: flex;
    align-items: center;
  }

  .tracking-address-detail-wrapper .shimmer.shimmer-thumbnail.border-rounded {
    width: 100%;
    height: 378px !important;
    border: 2px solid #f8f8f8;
    border-radius: 34px;
    padding: 34px 38px;
    position: relative;
    margin-bottom: 0px;
}

.contact-person-detail-wrapper .shimmer.shimmer-thumbnail.border-rounded{
    width: 100%;
    height: 326px !important;
    border: 2px solid #f8f8f8;
    border-radius: 34px;
    /* padding: 26px 40px; */
    padding: 34px 65px 34px 48px;
    margin-top: 20px;
    opacity: 0.6;
}

.shimmer-traking-header-wrap{
    width: 46%;
}

.shimmer-traking-header-wrap .shimmer-title-line {
    width: 100%;
    height: 30px;
    border-radius: 12px;
}

.profile-picture-main-wrap .shimmer.shimmer-avatar {
    width: 140px !important;
    height: 140px !important;
    margin: 0px;
}

.profile-heading-wrap .shimmer.shimmer-avatar {
    width: 32px !important;
    height: 32px !important;
    margin: 0px;
    padding: 0px;
    margin-top: 10px;
}


.shimmer-profile-basic-info-wrap{
    position: relative;
    width: 100%;
}

.shimmer-profile-basic-info-wrap .shimmer.shimmer-thumbnail.border-rounded{
    height: 406px !important; 
    border-radius: 34px;
    margin: 0px;
}

.postpaid-drawer-shimer-wrap{
    display: flex;
    flex-direction: column;
    justify-content: center;
    justify-content: center;
    height: calc(100vh - 150px);
}


.postpaid-drawer-shimer-wrap .shimmer.shimmer-thumbnail.border-rounded {
    width: 190px;
    height: 190px !important;
    margin: 0 auto;
    margin-bottom: 25px;
}

.postpaid-drawer-shimer-wrap > div {
    text-align: center;
    width: 100%;
}

.pofile-detail-main-wrap .grid.shimmer-title.grid-gap-8 {
    width: 300px;
    gap: 10px;
}


.pofile-detail-main-wrap .shimmer-title-line:first-child {
    width: 60% !important;
    height: 20px;
}

.pofile-detail-main-wrap .shimmer-title-line:last-child {
    width: 100% !important;
    height: 12px;
}

@media (min-width: 1200px) and (max-width: 1599px) {
    .dashboard-history-main-wrap .shimmer.shimmer-thumbnail.border-rounded {
        height: 107px !important;
    }

    .service-item-grid .shimmer-card {
        height: 108px;
    }

    .summer-effect-item-wrap{
        margin-top: 0px;
    }

    .tracking-address-detail-wrapper .shimmer.shimmer-thumbnail.border-rounded {
        height: 258px !important;
        border-radius: 24px;
        padding: 18px 20px;
    }

    .contact-person-detail-wrapper .shimmer.shimmer-thumbnail.border-rounded {
        border-radius: 24px;
        padding: 26px 50px 26px 32px;
        height: 247px !important;
    }

    .home-service-detail-main-wrapper .shimmer.shimmer-thumbnail.border-rounded {
        border-radius: 24px;
        padding: 18px 30px;
        height: 525px !important;
    }

    .profile-picture-main-wrap .shimmer.shimmer-avatar {
        width: 108px !important;
        height: 108px !important;
    }

    .shimmer-profile-basic-info-wrap .shimmer.shimmer-thumbnail.border-rounded{
        height: 282px !important; 
        border-radius: 24px;
        margin: 0px;
    }
}


@media (min-width: 1025px) and (max-width: 1199px) {
    .dashboard-history-main-wrap .shimmer.shimmer-thumbnail.border-rounded {
        height: 90px !important;
    }

    .service-item-grid .shimmer-card {
        width: 120px !important;
        height: 110px;
    }

    .summer-effect-item-wrap{
        margin-top: 0px;
    }

    .tracking-address-detail-wrapper .shimmer.shimmer-thumbnail.border-rounded {
        height: 258px !important;
        border-radius: 24px;
        padding: 18px 20px;
    }

    .contact-person-detail-wrapper .shimmer.shimmer-thumbnail.border-rounded {
        border-radius: 24px;
        padding: 26px 50px 26px 32px;
        height: 247px !important;
    }

    .home-service-detail-main-wrapper .shimmer.shimmer-thumbnail.border-rounded {
        border-radius: 24px;
        padding: 18px 30px;
        height: 525px !important;
    }

    .profile-picture-main-wrap .shimmer.shimmer-avatar {
        width: 108px !important;
        height: 108px !important;
    }

    .shimmer-profile-basic-info-wrap .shimmer.shimmer-thumbnail.border-rounded{
        height: 282px !important; 
        border-radius: 24px;
        margin: 0px;
    }
    
}


@media (min-width: 768px) and (max-width: 1024px) {
    .dashboard-history-main-wrap .shimmer.shimmer-thumbnail.border-rounded {
        height: 150px !important;
    }


    .summer-effect-item-wrap{
        margin-top: 0px;
        gap: 20px;
    }

    .service-item-grid .shimmer-card {
        width: 140px !important;
        height: 180px;
    }
}

@media (max-width: 1024px) {
    .dashboard-history-main-wrap .shimmer.shimmer-thumbnail.border-rounded {
        height: 141px !important;
    }

    .summer-effect-item-wrap{
        margin-top: 0px;
        gap: 20px;
    }

    .service-item-grid .shimmer-card {
        width: 140px !important;
        height: 180px;
    }

    .contact-person-detail-wrapper .shimmer.shimmer-thumbnail.border-rounded {
        border-radius: 24px;
        padding: 26px 50px 26px 32px;
        height: 200px !important;
    }

    .home-service-detail-main-wrapper .shimmer.shimmer-thumbnail.border-rounded {
        border-radius: 24px;
        padding: 18px 30px;
        height: calc(100vh - 400px) !important;
    }


    .shimmer-traking-header-wrap{
        width: 80%;
    }

    .shimmer-traking-header-wrap .shimmer-title-line {
        width: 100%;
        height: 26px;
        border-radius: 12px;
    }

    .profile-picture-main-wrap .shimmer.shimmer-avatar {
        width: 145px !important;
        height: 145px !important;
    }

    .pofile-detail-main-wrap .shimmer-title-line:first-child {
        width: 200px !important;
    }

    .pofile-detail-main-wrap .shimmer-title-line:last-child {
        width: 240px !important;
    }

    .pofile-detail-main-wrap .grid.shimmer-title.grid-gap-8 {
        width: 100%;
    }
}


@media (min-width: 1600px) {
    .home-service-detail-main-wrapper .shimmer.shimmer-thumbnail.border-rounded {
        width: 100%;
        border: 2px solid #f8f8f8;
        border-radius: 34px;
        opacity: 0.6;
        height: 724px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/Shimmer.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;;EAGE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,wBAAwB;IACxB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,yBAAyB;IACzB,mBAAmB;IACnB,wBAAwB;IACxB,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,2BAA2B;AAC/B;;;AAGA;IACI,YAAY;IACZ,wBAAwB;IACxB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;;AAGA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;QACxB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,4BAA4B;QAC5B,wBAAwB;IAC5B;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,wBAAwB;IAC5B;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;QACxB,mBAAmB;QACnB,WAAW;IACf;AACJ;;;AAGA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;QACxB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,4BAA4B;QAC5B,wBAAwB;IAC5B;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,wBAAwB;IAC5B;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;QACxB,mBAAmB;QACnB,WAAW;IACf;;AAEJ;;;AAGA;IACI;QACI,wBAAwB;IAC5B;;;IAGA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,uBAAuB;QACvB,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,4BAA4B;QAC5B,wBAAwB;IAC5B;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,sCAAsC;IAC1C;;;IAGA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;AACJ;;;AAGA;IACI;QACI,WAAW;QACX,yBAAyB;QACzB,mBAAmB;QACnB,YAAY;QACZ,wBAAwB;IAC5B;AACJ","sourcesContent":[".dashboard-history-main-wrap .shimmer.shimmer-thumbnail.border-rounded {\r\n    padding-bottom: 0px;\r\n    margin-bottom: 0px;\r\n    border-radius: 20px;\r\n    height: 163px !important;\r\n}\r\n\r\n.service-item-grid .shimmer-card {\r\n    width: 103px !important;\r\n    height: 134px;\r\n    border: 1px solid #f3f3f3;\r\n    border-radius: 15px;\r\n    box-shadow: unset;\r\n    overflow: hidden;\r\n}\r\n\r\n.shimmer-service-item-card-wrap{\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.summer-effect-item-wrap{\r\n    margin-top: 12px;\r\n}\r\n\r\n.shimmer.shimmer-thumbnail.mb-0 {\r\n    height: 78px !important;\r\n}\r\n\r\n.service-item-grid .p-30 {\r\n    padding: 4px 16px;\r\n}\r\n\r\n.shimmer-title--secondary .shimmer-title-line {\r\n    height: 10px;\r\n}\r\n\r\n\r\n  .service-item-grid{\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n  .tracking-address-detail-wrapper .shimmer.shimmer-thumbnail.border-rounded {\r\n    width: 100%;\r\n    height: 378px !important;\r\n    border: 2px solid #f8f8f8;\r\n    border-radius: 34px;\r\n    padding: 34px 38px;\r\n    position: relative;\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.contact-person-detail-wrapper .shimmer.shimmer-thumbnail.border-rounded{\r\n    width: 100%;\r\n    height: 326px !important;\r\n    border: 2px solid #f8f8f8;\r\n    border-radius: 34px;\r\n    /* padding: 26px 40px; */\r\n    padding: 34px 65px 34px 48px;\r\n    margin-top: 20px;\r\n    opacity: 0.6;\r\n}\r\n\r\n.shimmer-traking-header-wrap{\r\n    width: 46%;\r\n}\r\n\r\n.shimmer-traking-header-wrap .shimmer-title-line {\r\n    width: 100%;\r\n    height: 30px;\r\n    border-radius: 12px;\r\n}\r\n\r\n.profile-picture-main-wrap .shimmer.shimmer-avatar {\r\n    width: 140px !important;\r\n    height: 140px !important;\r\n    margin: 0px;\r\n}\r\n\r\n.profile-heading-wrap .shimmer.shimmer-avatar {\r\n    width: 32px !important;\r\n    height: 32px !important;\r\n    margin: 0px;\r\n    padding: 0px;\r\n    margin-top: 10px;\r\n}\r\n\r\n\r\n.shimmer-profile-basic-info-wrap{\r\n    position: relative;\r\n    width: 100%;\r\n}\r\n\r\n.shimmer-profile-basic-info-wrap .shimmer.shimmer-thumbnail.border-rounded{\r\n    height: 406px !important; \r\n    border-radius: 34px;\r\n    margin: 0px;\r\n}\r\n\r\n.postpaid-drawer-shimer-wrap{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    justify-content: center;\r\n    height: calc(100vh - 150px);\r\n}\r\n\r\n\r\n.postpaid-drawer-shimer-wrap .shimmer.shimmer-thumbnail.border-rounded {\r\n    width: 190px;\r\n    height: 190px !important;\r\n    margin: 0 auto;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.postpaid-drawer-shimer-wrap > div {\r\n    text-align: center;\r\n    width: 100%;\r\n}\r\n\r\n.pofile-detail-main-wrap .grid.shimmer-title.grid-gap-8 {\r\n    width: 300px;\r\n    gap: 10px;\r\n}\r\n\r\n\r\n.pofile-detail-main-wrap .shimmer-title-line:first-child {\r\n    width: 60% !important;\r\n    height: 20px;\r\n}\r\n\r\n.pofile-detail-main-wrap .shimmer-title-line:last-child {\r\n    width: 100% !important;\r\n    height: 12px;\r\n}\r\n\r\n@media (min-width: 1200px) and (max-width: 1599px) {\r\n    .dashboard-history-main-wrap .shimmer.shimmer-thumbnail.border-rounded {\r\n        height: 107px !important;\r\n    }\r\n\r\n    .service-item-grid .shimmer-card {\r\n        height: 108px;\r\n    }\r\n\r\n    .summer-effect-item-wrap{\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .tracking-address-detail-wrapper .shimmer.shimmer-thumbnail.border-rounded {\r\n        height: 258px !important;\r\n        border-radius: 24px;\r\n        padding: 18px 20px;\r\n    }\r\n\r\n    .contact-person-detail-wrapper .shimmer.shimmer-thumbnail.border-rounded {\r\n        border-radius: 24px;\r\n        padding: 26px 50px 26px 32px;\r\n        height: 247px !important;\r\n    }\r\n\r\n    .home-service-detail-main-wrapper .shimmer.shimmer-thumbnail.border-rounded {\r\n        border-radius: 24px;\r\n        padding: 18px 30px;\r\n        height: 525px !important;\r\n    }\r\n\r\n    .profile-picture-main-wrap .shimmer.shimmer-avatar {\r\n        width: 108px !important;\r\n        height: 108px !important;\r\n    }\r\n\r\n    .shimmer-profile-basic-info-wrap .shimmer.shimmer-thumbnail.border-rounded{\r\n        height: 282px !important; \r\n        border-radius: 24px;\r\n        margin: 0px;\r\n    }\r\n}\r\n\r\n\r\n@media (min-width: 1025px) and (max-width: 1199px) {\r\n    .dashboard-history-main-wrap .shimmer.shimmer-thumbnail.border-rounded {\r\n        height: 90px !important;\r\n    }\r\n\r\n    .service-item-grid .shimmer-card {\r\n        width: 120px !important;\r\n        height: 110px;\r\n    }\r\n\r\n    .summer-effect-item-wrap{\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .tracking-address-detail-wrapper .shimmer.shimmer-thumbnail.border-rounded {\r\n        height: 258px !important;\r\n        border-radius: 24px;\r\n        padding: 18px 20px;\r\n    }\r\n\r\n    .contact-person-detail-wrapper .shimmer.shimmer-thumbnail.border-rounded {\r\n        border-radius: 24px;\r\n        padding: 26px 50px 26px 32px;\r\n        height: 247px !important;\r\n    }\r\n\r\n    .home-service-detail-main-wrapper .shimmer.shimmer-thumbnail.border-rounded {\r\n        border-radius: 24px;\r\n        padding: 18px 30px;\r\n        height: 525px !important;\r\n    }\r\n\r\n    .profile-picture-main-wrap .shimmer.shimmer-avatar {\r\n        width: 108px !important;\r\n        height: 108px !important;\r\n    }\r\n\r\n    .shimmer-profile-basic-info-wrap .shimmer.shimmer-thumbnail.border-rounded{\r\n        height: 282px !important; \r\n        border-radius: 24px;\r\n        margin: 0px;\r\n    }\r\n    \r\n}\r\n\r\n\r\n@media (min-width: 768px) and (max-width: 1024px) {\r\n    .dashboard-history-main-wrap .shimmer.shimmer-thumbnail.border-rounded {\r\n        height: 150px !important;\r\n    }\r\n\r\n\r\n    .summer-effect-item-wrap{\r\n        margin-top: 0px;\r\n        gap: 20px;\r\n    }\r\n\r\n    .service-item-grid .shimmer-card {\r\n        width: 140px !important;\r\n        height: 180px;\r\n    }\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n    .dashboard-history-main-wrap .shimmer.shimmer-thumbnail.border-rounded {\r\n        height: 141px !important;\r\n    }\r\n\r\n    .summer-effect-item-wrap{\r\n        margin-top: 0px;\r\n        gap: 20px;\r\n    }\r\n\r\n    .service-item-grid .shimmer-card {\r\n        width: 140px !important;\r\n        height: 180px;\r\n    }\r\n\r\n    .contact-person-detail-wrapper .shimmer.shimmer-thumbnail.border-rounded {\r\n        border-radius: 24px;\r\n        padding: 26px 50px 26px 32px;\r\n        height: 200px !important;\r\n    }\r\n\r\n    .home-service-detail-main-wrapper .shimmer.shimmer-thumbnail.border-rounded {\r\n        border-radius: 24px;\r\n        padding: 18px 30px;\r\n        height: calc(100vh - 400px) !important;\r\n    }\r\n\r\n\r\n    .shimmer-traking-header-wrap{\r\n        width: 80%;\r\n    }\r\n\r\n    .shimmer-traking-header-wrap .shimmer-title-line {\r\n        width: 100%;\r\n        height: 26px;\r\n        border-radius: 12px;\r\n    }\r\n\r\n    .profile-picture-main-wrap .shimmer.shimmer-avatar {\r\n        width: 145px !important;\r\n        height: 145px !important;\r\n    }\r\n\r\n    .pofile-detail-main-wrap .shimmer-title-line:first-child {\r\n        width: 200px !important;\r\n    }\r\n\r\n    .pofile-detail-main-wrap .shimmer-title-line:last-child {\r\n        width: 240px !important;\r\n    }\r\n\r\n    .pofile-detail-main-wrap .grid.shimmer-title.grid-gap-8 {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n\r\n@media (min-width: 1600px) {\r\n    .home-service-detail-main-wrapper .shimmer.shimmer-thumbnail.border-rounded {\r\n        width: 100%;\r\n        border: 2px solid #f8f8f8;\r\n        border-radius: 34px;\r\n        opacity: 0.6;\r\n        height: 724px !important;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
